import React from "react";
import {Button, Dialog, DialogActions, DialogContent, Typography} from "@mui/material";

export default function ClientDialog({open, onClose, client, onViewFullProfile}) {
    if (!client) return null;

    return (
        <Dialog open={open} onClose={onClose} fullWidth>
            <DialogContent>
                <Typography variant="h6">{client.name}</Typography>
                <Typography variant="body2">{client.email}</Typography>
                <Typography variant="body2">{client.phone}</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Fermer</Button>
                <Button variant="contained" onClick={onViewFullProfile}>Ouvrir fiche complète</Button>
            </DialogActions>
        </Dialog>
    );
}
